<template>
  <aside class="member-card">
    <div class="member-card__header">
      <div class="logo-box">
        <!-- 가로형 로고(투명배경) 파일을 표시 -->
        <img
          class="logo-img"
          :src="avatarSrc || brandMark"
          alt="brand mark"
          loading="lazy"
        />
      </div>
      <div class="greet">
        <div class="hello">반갑습니다</div>
        <div class="name">
          <strong>{{ user.name }}</strong> 회원님
        </div>
      </div>

      <!-- 구분선 -->
      <div class="divider"></div>
    </div>

    <ul class="member-meta">
      <li>
        <span class="label">회원권</span
        ><span class="value">{{ user.membership || "-" }}</span>
      </li>
      <li>
        <span class="label">만료일자</span
        ><span class="value">{{ user.expiredAt || "-" }}</span>
      </li>
      <li>
        <span class="label">남은 수업</span
        ><span class="value">{{ user.remaining || "-" }}</span>
      </li>
    </ul>
  </aside>
</template>

<script>
import brandMark from "@/assets/logo/brand-mark.png"; // ← 가로형 로고(예: 176x88)

export default {
  name: "MemberInfoCard",
  props: {
    user: {
      type: Object,
      default: () => ({
        name: "노종택",
        membership: "-",
        expiredAt: "-",
        remaining: "-",
      }),
    },
    avatarSrc: { type: String, default: "" },
  },
  data() {
    return { brandMark };
  },
};
</script>

<style scoped>
.member-card {
  width: 280px;
  background: #151718;
  border-radius: 10px;
  padding: 16px;
  color: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}
.member-card__header {
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 12px;
  align-items: center;
}
.logo-box {
  width: 72px;
  height: 72px;
  border-radius: 10px;
  background: #012f00;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.logo-img {
  height: 50px; /* 로고 고정 높이 */
  width: 64px; /* 비율 유지 */
  max-width: 52px; /* 너무 길어질 때 보호 */
}
.greet .hello {
  color: #c8c8c8;
  font-size: 14px;
}
.greet .name {
  font-size: 16px;
  letter-spacing: -0.02em;
}

.divider {
  grid-column: 1 / -1;
  height: 1px;
  background: rgba(255, 255, 255, 0.12);
  margin-top: 12px;
}

.member-meta {
  list-style: none;
  padding: 12px 0 0;
  margin: 0;
  display: grid;
  gap: 10px;
}
.member-meta li {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.member-meta .label {
  color: #c8c8c8;
}
.member-meta .value {
  color: #fff;
}
</style>
